import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userLocale: 'en-GB',
  supportedLanguages: [],
  storeId: 14766,
  floorStatics: {},
  HomeStatics: {},
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setReduxLocale: (state, action) => {
      state.userLocale = action.payload;
    },
    setSupportedLanguages: (state, action) => {
      state.supportedLanguages = action.payload;
    },
    setStoreId: (state, action) => {
      state.storeId = action.payload;
    },
    setStoreStatics: (state, action) => {
      state.floorStatics = action.payload.floorStatics;
      state.HomeStatics = action.payload.HomeStatics;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setReduxLocale,
  setSupportedLanguages,
  setStoreId,
  setStoreStatics,
} = configSlice.actions;
